/** Reports / dashboard / activity log feature reducers */
export async function loadReportsReducers() {
  const [reports, posReports, dailyReport, dashboard, activityLog, newDesignDashboard, newDesignDashboardData] = await Promise.all([
    import('../reducers/ReportsReducer'),
    import('../reducers/PosReportsReducer'),
    import('../reducers/DailyReportReducer'),
    import('../reducers/DashboardReducer'),
    import('../reducers/ActivityLogReducer'),
    import('../reducers/NewDesignDashboardReducer'),
    import('../reducers/NewDesignDashboardDataReducer'),
  ]);

  return {
    reports: reports.default,
    posReports: posReports.default,
    dailyReport: dailyReport.default,
    dashboard: dashboard.default,
    activityLog: activityLog.default,
    newDesignDashboard: newDesignDashboard.default,
    newDesignDashboardData: newDesignDashboardData.default,
  };
}
